import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastError = err => {
	// ✅ CORREÇÃO: Verificar tanto 'error' quanto 'message' no response
	const errorMsg = err.response?.data?.error || err.response?.data?.message;
	
	if (errorMsg) {
		// Tentar buscar tradução usando o caminho completo
		const translationPath = `backendErrors.${errorMsg}`;
		
		// Verificar se a tradução existe antes de tentar buscar
		let translatedMessage = null;
		try {
			// Tentar buscar a tradução
			translatedMessage = i18n.t(translationPath, { defaultValue: null });
			
			// Se retornou null ou a própria chave, significa que não encontrou
			if (!translatedMessage || translatedMessage === translationPath) {
				translatedMessage = null;
			}
		} catch (e) {
			// Se der erro ao buscar tradução, usar null
			translatedMessage = null;
		}
		
		// Se encontrou tradução, usar ela; senão, usar a mensagem original do backend
		const messageToShow = translatedMessage || errorMsg;
		
		toast.error(messageToShow, {
			toastId: errorMsg,
			autoClose: 3000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: false,
			draggable: true,
			progress: undefined,
			theme: "light",
			style: {
				zIndex: 10004
			}
		});
		return
	} if (isString(err)) {
		toast.error(err, {
			style: {
				zIndex: 10004
			}
		});
		return
	} else if (err?.message && isString(err.message)) {
		toast.error(err.message, {
			style: {
				zIndex: 10004
			}
		});
		return
	} else {
		toast.error("Ocorreu um erro!", {
			style: {
				zIndex: 10004
			}
		});
		return
	}
};

export default toastError;
